import React from 'react';
import { FrownIcon, SmileIcon, ArrowDownIcon } from 'lucide-react';
export function BeforeAfter() {
  const beforeItems = [{
    emoji: '😩',
    text: 'Domingo 23:00 hs. Todavía armando material para mañana.'
  }, {
    emoji: '😤',
    text: 'Buscando en Pinterest 2 horas para encontrar UNA actividad que sirva.'
  }, {
    emoji: '😰',
    text: 'Informes sin rúbricas. Escribís lo mismo para todos y sentís que no alcanza.'
  }, {
    emoji: '😓',
    text: 'Planificación = copiar y pegar cosas sueltas sin coherencia ni secuencia.'
  }, {
    emoji: '😢',
    text: 'Reunión con familias y no sabés cómo explicar lo que observás.'
  }, {
    emoji: '😵',
    text: 'Sentís que improvisás más de lo que profesionalizás.'
  }, {
    emoji: '💸',
    text: 'Gastaste miles en cursos que te dieron teoría pero CERO material práctico.'
  }];
  const afterItems = [{
    emoji: '😌',
    text: 'Domingo libre. Todo el año ya está planificado.'
  }, {
    emoji: '⚡',
    text: 'Abrís el tomo, imprimís y listo. 5 minutos.'
  }, {
    emoji: '📋',
    text: 'Informes profesionales con rúbricas claras. En 2 horas terminás todo.'
  }, {
    emoji: '🎯',
    text: 'Secuencias completas con objetivos, actividades y evaluación integrada.'
  }, {
    emoji: '💬',
    text: 'Guías de reunión paso a paso. Sabés exactamente qué decir.'
  }, {
    emoji: '👩‍⚕️',
    text: 'Trabajás con un sistema profesional que te respalda.'
  }, {
    emoji: '✅',
    text: 'Una sola inversión. Material para TODO el año. Sin vueltas.'
  }];
  return <section className="w-full py-10 bg-[#111111]" data-id="element-22">
      <div className="max-w-5xl mx-auto px-4 md:px-6" data-id="element-23">
        <h2 className="text-2xl md:text-4xl font-bold text-white mb-2 text-center font-['Open_Sans',_sans-serif]" data-id="element-24">
          La realidad que <span className="text-red-500" data-id="element-25">nadie te dice</span>{' '}
          vs. lo que{' '}
          <span className="text-[#D4A843]" data-id="element-26">podría ser tu vida profesional</span>
        </h2>
        <p className="text-center text-gray-400 mb-8 text-sm md:text-base" data-id="element-27">
          Mirá la diferencia entre seguir como estás… o tener el MegaPack hoy.
        </p>

        {/* ANTES - Pain heavy */}
        <div className="mb-4" data-id="element-28">
          <div className="flex items-center gap-2 mb-4" data-id="element-29">
            <FrownIcon className="w-7 h-7 text-red-500" data-id="element-30" />
            <h3 className="text-xl md:text-2xl font-bold text-red-500 uppercase tracking-wide" data-id="element-31">
              ❌ ANTES — Sin el MegaPack
            </h3>
          </div>
          <div className="bg-red-500/5 border border-red-500/20 rounded-xl p-4 md:p-6 space-y-3" data-id="element-32">
            {beforeItems.map((item, i) => <div key={i} className="flex items-start gap-3 bg-[#1A1A1A] border border-red-500/10 rounded-lg px-4 py-3" data-id="element-33">
                <span className="text-xl flex-shrink-0 mt-0.5" data-id="element-34">
                  {item.emoji}
                </span>
                <p className="text-gray-300 text-sm md:text-base leading-relaxed" data-id="element-35">
                  {item.text}
                </p>
              </div>)}
          </div>
        </div>

        {/* Arrow transition */}
        <div className="flex flex-col items-center my-6" data-id="element-36">
          <div className="bg-[#D4A843] rounded-full p-3 shadow-[0_0_20px_rgba(212,168,67,0.4)] animate-bounce" data-id="element-37">
            <ArrowDownIcon className="w-6 h-6 text-black" data-id="element-38" />
          </div>
          <p className="text-[#D4A843] font-bold text-lg mt-2 font-['Open_Sans',_sans-serif]" data-id="element-39">
            CON EL MEGAPACK TODO CAMBIA
          </p>
        </div>

        {/* DESPUÉS - Relief */}
        <div className="mb-6" data-id="element-40">
          <div className="flex items-center gap-2 mb-4" data-id="element-41">
            <SmileIcon className="w-7 h-7 text-[#D4A843]" data-id="element-42" />
            <h3 className="text-xl md:text-2xl font-bold text-[#D4A843] uppercase tracking-wide" data-id="element-43">
              ✅ DESPUÉS — Con el MegaPack
            </h3>
          </div>
          <div className="bg-[#D4A843]/5 border border-[#D4A843]/20 rounded-xl p-4 md:p-6 space-y-3" data-id="element-44">
            {afterItems.map((item, i) => <div key={i} className="flex items-start gap-3 bg-[#1A1A1A] border border-[#D4A843]/15 rounded-lg px-4 py-3" data-id="element-45">
                <span className="text-xl flex-shrink-0 mt-0.5" data-id="element-46">
                  {item.emoji}
                </span>
                <p className="text-gray-200 text-sm md:text-base leading-relaxed font-medium" data-id="element-47">
                  {item.text}
                </p>
              </div>)}
          </div>
        </div>

        {/* Aggressive closing */}
        <div className="bg-[#0A0A0A] border-2 border-[#D4A843]/40 rounded-xl p-6 text-center space-y-3" data-id="element-48">
          <p className="text-xl md:text-2xl font-bold text-white leading-snug" data-id="element-49">
            ¿Cuántos domingos más vas a perder armando material a las apuradas?
          </p>
          <p className="text-red-400 text-sm md:text-base" data-id="element-50">
            Cada semana que pasa sin un sistema profesional es tiempo, energía y
            salud mental que no recuperás.
          </p>
          <a href="#ofertas" className="inline-block bg-[#D4A843] hover:bg-[#B8912E] text-white font-bold px-8 py-4 rounded-lg transition-all duration-200 hover:scale-105 text-sm md:text-base shadow-[0_0_20px_rgba(212,168,67,0.3)] mt-2" data-id="element-51">
            🧮→ QUIERO DEJAR DE IMPROVISAR — DAME EL MEGAPACK
          </a>
        </div>
      </div>
    </section>;
}